const isSafeDataUrl = (s) => /^data:image\/(png|jpeg|jpg|gif|webp);base64,[A-Za-z0-9+/=]+$/.test(s)

const sanitizeImageUrl = (raw) => {
  if (!raw)
    return null
  // Allow a strict set of data image URIs if you need them
  if (raw.startsWith('data:'))
    return isSafeDataUrl(raw) ? raw : null

  try {
    const parsed = new URL(raw, window.location.origin)
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      // URL.href is percent-encoded and safe to interpolate
      return parsed.href
    }
  } catch (e) {
    // invalid URL
  }
  return null
}

export default sanitizeImageUrl
